'use client'

import { DateRange, useInquiriesFilter } from '@repo/sdk'
import {
  Button,
  Calendar,
  CompanyInput,
  Label,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/ui'
import { z } from 'zod'

export const FilterBar = ({
  cargoType,
  companyId,
  criterium,
  dateRange,
  loadTypes,
  resetFilters,
  setCargoType,
  setCompanyId,
  setCriterium,
  setDateRange,
}: ReturnType<typeof useInquiriesFilter>) => {
  return (
    <div className="flex w-full items-end gap-2">
      <div className="w-1/4">
        <Label htmlFor="company">Company</Label>
        <CompanyInput
          onChange={event => setCompanyId(event)}
          value={z
            .number()
            .nullish()
            .transform(value => (value === null ? undefined : value))
            .parse(companyId)}
        />
      </div>
      <div className={'flex min-w-44 flex-col gap-1'}>
        <Label>Date</Label>
        <Popover>
          <PopoverTrigger asChild>
            <Button className="w-full" type="button" variant="outline">
              {criterium}: {dateRange.from?.toLocaleDateString()} -{' '}
              {dateRange.to?.toLocaleDateString('en-GB')}
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-max">
            <Select onValueChange={setCriterium} value={criterium}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="created_at">Created at</SelectItem>
                <SelectItem value="collection">Collection</SelectItem>
                <SelectItem value="delivery">Delivery</SelectItem>
              </SelectContent>
            </Select>
            {criterium && (
              <>
                <Calendar
                  classNames={{
                    selected: 'bg-brand',
                  }}
                  mode="range"
                  onSelect={dateRange => setDateRange(dateRange as DateRange)}
                  selected={dateRange as DateRange}
                />
                <div className="flex justify-end">
                  <Button onClick={resetFilters} size="sm">
                    Reset
                  </Button>
                </div>
              </>
            )}
          </PopoverContent>
        </Popover>
      </div>

      <div className={'w-1/6'}>
        <Label>Truck Type</Label>
        <Select onValueChange={setCargoType} value={cargoType ?? undefined}>
          <SelectTrigger className="h-[42px]">
            <SelectValue placeholder={'Truck type'} />
          </SelectTrigger>
          <SelectContent className="z-[1600]">
            {loadTypes?.map(loadType =>
              loadType.options.map(opt => (
                <SelectItem key={opt.id} value={opt.id.toString()}>
                  {opt.title}
                </SelectItem>
              )),
            )}
          </SelectContent>
        </Select>
      </div>

      <Button onClick={resetFilters}>Reset</Button>
    </div>
  )
}
